<template>
  <div class="footer">
    <div class="footer__logos">
      <ul class="footer__logos__list">
        <li v-for="logo in logoList"
            class="footer__logos__item">
          <img :src="logo.url"
               alt="Logo">
        </li>
      </ul>
      <div class="legal-links">
        <div v-if="urlsLoaded || editMode">
          <a :href="!editMode && createLink('impressum')"
             v-word:layout.footer.link.impressum
             :target="createTarget('impressum')" />
          |
          <a :href="!editMode && createLink('agb')"
             v-word:layout.footer.link.agb
             :target="createTarget('agb')" />
          |
          <a :href="!editMode && createLink('policy')"
             v-word:layout.footer.link.policy
             :target="createTarget('policy')" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import instanceConfig from '../utils/instanceConfig';
import url from '../utils/url';
import * as mixins from '../mixins';

export default {
  mixins: [mixins.wordedPage],
  props: ['editMode'],
  data() {
    return {
      logoList: [],
      urls: {},
      urlsLoaded: false,
    };
  },
  created() {
    !this.editMode &&
      instanceConfig
        .loadLogoList()
        .then(logoList => this.replaceLogoList(logoList))
        .catch(() => {});

    !this.editMode &&
      instanceConfig
        .loadUrls()
        .then(urls => {
          this.urls = urls;
          this.urlsLoaded = true;
        })
        .catch(() => {});
  },
  methods: {
    replaceLogoList(logoList) {
      this.logoList = [];

      for (let logo of logoList) {
        this.logoList.push({
          id: logo.id,
          url: url.randomize(logo.url),
        });
      }
    },
    createLink(urlId) {
      return this.urls[urlId]
        ? this.urls[urlId]
        : this.$router.resolve({ name: urlId }).href;
    },
    createTarget(urlId) {
      if (
        typeof this.urls === 'object' &&
        this.urls.hasOwnProperty(urlId)
      ) {
        return '_blank';
      }
      return '';
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/layout/Footer.vue